import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { editLoan } from '../../features/loans/loanAPI';
import useEthers from '../../hooks/useEthers';
import Ex from '../../pages/ex/Ex';

function RepayCard(loan) {
  const [showModal, setShowModal] = useState(false);
  const [repaymentAmount, setRepaymentAmount] = useState('');
  const time = new Date(loan.createdAt).toISOString();
  const { switchNetwork, Transfer } = useEthers();
  const dispatch = useDispatch();

  const handleBorrow = async (e) => {
    e.preventDefault();
    const loanData = {
      _id: loan._id,
      repaymentAmount: parseInt(loan.repaymentAmount) + parseInt(repaymentAmount),
      repaymentStatus: parseInt(loan.repaymentAmount) + parseInt(repaymentAmount) < parseInt(loan.repayedAmount) ? 'Partial' : 'Paid',
      loanStatus: loan.loanStatus
    };
    if (parseInt(loan.repaymentAmount) + parseInt(repaymentAmount) <= parseInt(loan.repayedAmount) && loan.loanStatus === 'Lent' && loan.repaymentStatus !== 'Paid' && repaymentAmount > 0) {
      await switchNetwork(loan.block);
      const cdt = await Transfer(e, loan.lenderWallet, repaymentAmount.toString(), loan._id, loan.block, loan.coin);
      try {
        cdt && await dispatch(editLoan(loanData))
          .unwrap()
          .then(() => {
            alert('Loan edited successfully');
          })
          .catch((error) => {
            alert('Error editing loan:', error.message || error);
          });
      }
      catch (error) {
        cdt && await dispatch(editLoan(loanData))
          .unwrap()
          .then(() => {
            alert('Loan edited successfully');
          })
          .catch((error) => {
            alert('Error editing loan:', error.message || error);
          });
      }
    }
    setRepaymentAmount('');
  };

  return (
    <main className="flex flex-col py-7 w-full bg-white rounded-3xl border border-solid border-neutral-200 shadow-[0px_2px_8px_rgba(0,0,0,0.25)] flex overflow-hidden flex-col py-5 bg-white rounded-2xl max-w-[473px]">
      <section className="flex flex-col px-5 w-full">
        <h1 className="self-start text-2xl font-medium leading-none text-black">
          Loan Repayment
        </h1>
        <div className="flex gap-10 items-center mt-8">
          <div className="flex flex-col self-stretch my-auto">
            <div className="text-sm leading-loose text-black text-opacity-60">
              Loan Amount
            </div>
            <div className="mt-1.5 text-base font-medium leading-loose text-black">
              ${loan.repayedAmount}
            </div>
          </div>
          <div className="flex flex-col self-stretch my-auto">
            <div className="text-sm leading-loose text-black text-opacity-60">
              Amount Paid
            </div>
            <div className="mt-1.5 text-base font-medium leading-loose text-black">
              ${loan.repaymentAmount}
              <span className="text-sm leading-6 text-black">{" ($" + (loan.repayedAmount - loan.repaymentAmount) + " Remaining)"}</span>
            </div>
          </div>
          <div className="flex flex-col self-stretch my-auto">
            <div className="text-sm leading-loose text-black text-opacity-60">
              Due Date
            </div>
            <div className="mt-1.5 text-base font-medium leading-loose text-black">
              {time.split("T")[0]}
            </div>
          </div>
        </div>
      </section>
      <hr className="mt-5 w-full border border-solid border-zinc-300 min-h-[1px]" />
      <section className="flex flex-col px-5 mt-5 w-full">
        <h2 className="self-start text-lg font-medium leading-loose text-black">
          Repayment Information
        </h2>
        <div className="flex overflow-hidden gap-10 p-4 mt-2.5 w-full whitespace-nowrap rounded-lg bg-neutral-100">
          <div className="flex flex-1 gap-4 items-center">
            <div className="self-stretch my-auto text-sm leading-loose text-black text-opacity-60">
              Stablecoin
            </div>
            <div className="flex gap-1.5 items-center self-stretch my-auto text-base font-medium leading-loose text-black">
              <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/36b2768ece14cc8c27f15df886baeb4d8561b26fdb09d2a7fd36f57790e94282?apiKey=e485b3dc4b924975b4554885e21242bb&" alt="" className="object-contain shrink-0 self-stretch my-auto w-7 aspect-square" />
              <div className="self-stretch my-auto">{loan.coin}</div>
            </div>
          </div>
          <div className="flex flex-1 gap-1.5 items-center self-start">
            <div className="self-stretch my-auto text-sm leading-loose text-black text-opacity-60">
              Network
            </div>
            <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/4ba089761d655b916ff23874ab3595e64d2f358d02957d03b3aaa8c77195070b?apiKey=e485b3dc4b924975b4554885e21242bb&" alt="" className="object-contain shrink-0 self-stretch my-auto w-6 aspect-square" />
            <div className="self-stretch my-auto text-base font-medium leading-loose text-black">
              {loan.block}
            </div>
          </div>
        </div>
        {/* <h3 className="self-start mt-8 text-lg font-medium leading-loose text-black">
          Repayment Amount
        </h3>
        <div className="gap-5 self-stretch p-5 mt-4 text-base leading-none bg-white rounded-lg border border-solid border-zinc-300 text-black text-opacity-60">
          Enter custom amount
        </div>
        <div className="flex gap-1.5 items-center self-start mt-4 text-base leading-loose whitespace-nowrap text-zinc-600">
          {percentages.map((percentage) => (
            <button
              key={percentage}
              className="gap-2.5 self-stretch px-4 py-2.5 my-auto rounded-lg border border-solid bg-zinc-100 border-white border-opacity-20"
            > const percentages = [25, 50, 75, 100];
              {percentage}%
            </button>
          ))}
        </div> */}
        <label for="repayment" className="block text-sm font-medium text-gray-700">Repayment Amount</label>
        <input
          type="number"
          min="0"
          id="repayment"
          name="repayment"
          placeholder="Enter custom amount"
          value={repaymentAmount}
          onChange={(e) => setRepaymentAmount(e.target.value)}
          className="mt-1 p-2 w-full border rounded-md focus:border-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 transition-colors duration-300"
        />
        <button onClick={handleBorrow} className="overflow-hidden gap-5 self-stretch p-5 mt-8 text-base font-medium leading-none text-center text-white bg-blue-600 rounded-lg">
          Repay Now
        </button>
        <p className="mt-5 text-sm leading-6 text-black text-opacity-60">
          You can repay any amount at any time before the due date. Ensure full repayment by the due date to maintain your credit score.
        </p>
        <p className="leading-7 text-black">
          Do you need to swap (any crypto) to stablecoin (suggested networks)?
        </p>
        <button onClick={() => setShowModal(true)} className="overflow-hidden gap-5 self-stretch px-5 py-4 mt-4 leading-none text-center text-white rounded-lg bg-slate-900">
          Swap Token Here
        </button>
        {showModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <button onClick={() => setShowModal(false)} className="text-gray-600 hover:text-gray-800 fixed top-4 right-4 z-50">
            ✖
          </button>
          <Ex block={loan.block} coin={loan.coin} />
        </div>}
      </section>
    </main>
  );
}

export default RepayCard;